import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import { CircleOutlined, Close } from "@mui/icons-material";

export type BuildingDoorListModalProps = {
  openBuildingModal: boolean;
  setOpenBuildingModal: (open: boolean) => void;
  autoBuildingId: number | undefined;
};

interface Building {
  autoBuildingId: number;
  buildingId: string;
  buildingManagementId: string;
  buildingName: string;
  buildingAddress: string;
  memo: string;
}

interface Door {
  autoSdcId: number;
  sdcSerialNumber: string;
  isOnline: boolean;
  lastDownloadedAt: Date;
  sdcUuid: string;
  doorPlace: string;
  doorId: string;
  memo: string;
  isRegisteredAsDoor: boolean;
  building: Building;
}

export const BuildingDoorListModal: React.FC<BuildingDoorListModalProps> = ({
  openBuildingModal,
  setOpenBuildingModal,
  autoBuildingId,
}) => {
  const [doors, setDoors] = useState<Door[]>([]);
  const [building, setBuilding] = useState<Building | undefined>(undefined);

  useEffect(() => {
    const fetchDoors = async () => {
      // JWTトークンを取得します
      const jwtToken = await getJwtTokenFromIdToken();
      try {
        // call indexSdcsWithAutoBuildingId API
        const response = await fetch(
          process.env.REACT_APP_API_ENDPOINT +
            `/buildings/${autoBuildingId}/sdcs`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: jwtToken,
            },
          }
        );
        const data = await response.json();
        setDoors(data.sdcs);
        console.log("ドア一覧取得データ" + JSON.stringify(data));
        if (data.sdcs.length > 0) {
          setBuilding(data.sdcs[0].building);
        }
      } catch (error) {
        console.error("Error fetching doors:", error);
      }
    };

    if (autoBuildingId !== undefined) {
      fetchDoors();
    }
  }, [autoBuildingId]);

  return (
    <Dialog
      open={openBuildingModal}
      onClose={() => setOpenBuildingModal(false)}
      maxWidth="lg"
    >
      <DialogTitle>ドア一覧</DialogTitle>
      <DialogContent>
        {building && (
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  物件システムID:
                </TableCell>
                <TableCell>{building.buildingId}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  取付先コード（物件管理ID）:
                </TableCell>
                <TableCell>{building.buildingManagementId}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                取付先名（物件名称）:
                </TableCell>
                <TableCell>{building.buildingName}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  物件住所:
                </TableCell>
                <TableCell>{building.buildingAddress}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  建物のメモ:
                </TableCell>
                <TableCell>{building.memo}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
        <TableContainer sx={{ marginTop: 1 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>SDCSN</TableCell>
                <TableCell>接続状態</TableCell>
                <TableCell>SDCが最後に鍵をDLした日時</TableCell>
                <TableCell>設置場所</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {doors.map((door, index) => (
                <TableRow key={index}>
                  <TableCell>{door.sdcSerialNumber}</TableCell>
                  <TableCell>
                    {door.isOnline ? (
                      <Tooltip title="オンライン">
                        <CircleOutlined sx={{ color: "green" }} />
                      </Tooltip>
                    ) : (
                      <Tooltip title="オフライン">
                        <Close sx={{ color: "red" }} />
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell>
                    {door.lastDownloadedAt ? (
                      <Tooltip
                        title={new Date(door.lastDownloadedAt).toLocaleString(
                          "ja-JP",
                          {
                            timeZone: "Asia/Tokyo",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          }
                        )}
                      >
                        <span>
                          {new Date(door.lastDownloadedAt).toLocaleString(
                            "ja-JP",
                            {
                              timeZone: "Asia/Tokyo",
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                        </span>
                      </Tooltip>
                    ) : (
                      <Tooltip title="記録なし">
                        <span>記録なし</span>
                      </Tooltip>
                    )}
                  </TableCell>
                  <TableCell>{door.doorPlace}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenBuildingModal(false)}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};
